<cds-modal-dialog [(isOpen)]="showModal" [ariaLabel]="(title || '') | adaFriendlyName: 'ada'" #cdsModalDialog [ngClass]="{'scrollable cbolui-cds-blue-vis-id': isModalScrollable}">
  <div class="cds-modal-content citi-modal">
    <div tabindex="-1" aria-hidden="true"></div>

    <div class="cds-modal-tophat">
      <button class="cds-modal-close-times" [ngClass]="{'cds-modal-close':!isModalScrollable, 'cds-modal-close-new':isModalScrollable}" type="button" aria-label="Close" (click)="close($event)"
        #intialModalFocus>
      </button>

    </div>

    <div class="cds-modal-header" *ngIf="title">
      <h2 class="cds-modal-title" [innerHTML]="title" tabindex="-1" #modalHeading></h2>
    </div>

    <div class="cds-modal-body" #cdsModalBody>
      <div class="htmlContent" *ngIf="htmlContent && !genericTemplateContent" [innerHTML]="htmlContent"></div>
      <app-generic-template *ngIf="genericTemplateContent" [content]="genericTemplateContent"></app-generic-template>
      <ng-content></ng-content>
    </div>

    <div *ngIf="(showCancelButton && cancelButtonText) || primaryButtonText" class="citi-modal-controls">
      <button type="button" cdsButton="primary" *ngIf="primaryButtonText"
        [ariaRole]="!primaryButtonUrl ? 'button' : null" class="modal-primary-btn btnclassTest w-auto"
        [attr.target]="primaryButtonTarget" [mktRouterLink]="primaryButtonUrl" [innerHTML]="primaryButtonText" [disabled]="false"
        (click)="(primaryButtonText === 'Close')? close($event):  continue($event)">
        </button>

        <button type="button" [cdsButton]="isModalScrollable ? 'primary' : 'tertiary'" #secondaryButton *ngIf="showCancelButton && cancelButtonText"
          class="modal-secondary-btn marginBetweenBtns" ariaRole="button" [type]="isModalScrollable ? 'primary' : 'tertiary'" [innerHTML]="cancelButtonText"
          (click)="close($event)">
          </button>
    </div>
  </div>
</cds-modal-dialog>
